




const SHOP_DATA = {
    lifestyle:{
        id: 1,
        title: "lifestyle",
        routeName: "lifestyle",
        items: [
            {
                id: 1,
                name: "model1",
                imageUrl: "https://i.ibb.co/MZ6sqxS/6b9df40e-077d-4a1a-867d-fd4eed19e3e9.png",
                price: 4,
                gender: "men"
            },
            {
                id: 2,
                name: "model2",
                imageUrl: "https://i.ibb.co/rtyBWVk/54f452f2-e844-4d69-9bfe-1012e7a17dde.png",
                price: 3,
                gender: "men"
            },
            {
                id: 3,
                name: "model3",
                imageUrl: "https://i.ibb.co/7nNzMp7/ajs0seil5tso35gv3ijr.png",
                price: 7,
                gender: "men"
            },
            {
                id: 4,
                name: "model4",
                imageUrl: "https://i.ibb.co/bsnXjH5/53213863-1aab-410d-9eef-ef73d3706f96-1.png",
                price: 2,
                gender: "men"
            },
            {
                id: 5,
                name: "model5",
                imageUrl: "https://i.ibb.co/Hxkyh6Q/d6x01w4f0xhusnmc4zka.png",
                price: 1,
                gender: "men"
            },
            {
                id: 6,
                name: "model6",
                imageUrl: "https://i.ibb.co/z7v9hPh/fcab7d3d-21ad-4276-8947-94a5ae66a797.png",
                price: 1,
                gender: "men"
            },
            {
                id: 7,
                name: "model7",
                imageUrl: "https://i.ibb.co/bbZhr0z/sxytufckkzavymbachbf.png",
                price: 8,
                gender: "men"
            },
            {
                id: 8,
                name: "model8",
                imageUrl: "https://i.ibb.co/TRzLpkF/tjd1keqy0vg7qp9fehbu.png",
                price: 7,
                gender: "men"
            },
            {
                id: 9,
                name: "model9",
                imageUrl: "https://i.ibb.co/TRzLpkF/tjd1keqy0vg7qp9fehbu.png",
                price: 4,
                gender: "men"
            },          
            {
                id: 10,
                name: "model10",
                imageUrl: "https://i.ibb.co/RzvZVPB/dkqtuq27jmz7xccnhejr.png",
                price: 9,
                gender: "women"
            },
            {
                id: 11,
                name: "model11",
                imageUrl: "https://i.ibb.co/yFnnVd2/12b950e1-621f-4915-b226-f9fb53d6a2c5.png",
                price: 3,
                gender: "women"
            },
            {
                id: 12,
                name: "model12",
                imageUrl: "https://i.ibb.co/44qVqfM/stzjis52otnsqdgtg7ur.png",
                price: 2,
                gender: "women"
            },
            {
                id: 13,
                name: "model13",
                imageUrl: "https://i.ibb.co/vjqfCKJ/1ba1bad1-4e57-49cf-9280-35425287431e.png",
                price: 6,
                gender: "women"
            },
            {
                id: 14,
                name: "model14",
                imageUrl: "https://i.ibb.co/Trc7rC0/s0jakfxbelq1rnmub2pj.png",
                price: 7,
                gender: "women"
            },
            {
                id: 15,
                name: "model15",
                imageUrl: "https://i.ibb.co/hKBsCH1/85fce457-6ff7-4116-83b2-c02aeea53db9.png",
                price: 9,
                gender: "women"
            }
        ]
    },
    running:{
        id: 2,
        title: "running",
        routeName: "running",
        items: [
            {
                id: 16,
                name: "model16",
                imageUrl: "https://i.ibb.co/1MrmX2N/34e2e91d-0e33-4780-8cb7-52f6d3630baa.png",
                price: 3,
                gender: "men"
            },
            {
                id: 17,
                name: "model17",
                imageUrl: "https://i.ibb.co/2yYMKdw/4d9fba69-03b8-421a-accd-c43d4ac59be0.png",
                price: 4,
                gender: "men"
            },
            {
                id: 18,
                name: "model18",
                imageUrl: "https://i.ibb.co/2yYMKdw/4d9fba69-03b8-421a-accd-c43d4ac59be0.png",
                price: 5,
                gender: "men"
            },
            {
                id: 19,
                name: "model19",
                imageUrl: "https://i.ibb.co/Jq9JjWk/p8t9bksg98ah6yc2whsx.png",
                price: 8,
                gender: "men"
            },
            {
                id: 20,
                name: "model20",
                imageUrl: "https://i.ibb.co/BGvWcWD/qxmh8yffpbydliov1jdg.png",
                price: 6,
                gender: "women"
            },
            {
                id: 21,
                name: "model21",
                imageUrl: "https://i.ibb.co/Pc1Vcsv/4adaed89-9219-437b-9dbf-00a634903e78.png",
                price: 9,
                gender: "men"
            },
            {
                id: 22,
                name: "model22",
                imageUrl: "https://i.ibb.co/vDWxGNM/046526a3-9fb2-43ac-993a-417310d32802.png",
                price: 3,
                gender: "men"
            },
            {
                id: 23,
                name: "model23",
                imageUrl: "https://i.ibb.co/NCPY6Y2/192c902b-a67f-4eec-832a-55288114f832.png",
                price: 8,
                gender: "men"
            },
            {
                id: 24,
                name: "model24",
                imageUrl: "https://i.ibb.co/bHx2rbD/4a12b841-69c3-44dd-a51f-631d36a1ae68.png",
                price: 3,
                gender: "men"
            },     
            {
                id: 25,
                name: "model25",
                imageUrl: "https://i.ibb.co/fqVPp9V/c1cxthvpjvhlxxyrbhfw.png",
                price: 9,
                gender: "women"
            },
            {
                id: 26,
                name: "model26",
                imageUrl: "https://i.ibb.co/vVkBhTd/711cdaca-49da-46d7-b643-537e1533ab27.png",
                price: 1,
                gender: "women"
            },
            {
                id: 27,
                name: "model27",
                imageUrl: "https://i.ibb.co/D7Mf9dW/1629d77e-b642-477c-89e3-a4142d9b535e.png",
                price: 1,
                gender: "women"
            },
            {
                id: 28,
                name: "model28",
                imageUrl: "https://i.ibb.co/C59WpBZ/84700f40-9ab0-41f0-928c-52110e815830.png",
                price: 6,
                gender: "women"
            },
            {
                id: 29,
                name: "model29",
                imageUrl: "https://i.ibb.co/NLvG0WZ/0acb0301-86ba-457e-ae8a-e683cb5f4070.png",
                price: 8,
                gender: "women"
            }
        ]
    },
    football:{
        id: 3,
        title: "football",
        routeName: "football",
        items: [
            {
                id: 30,
                name: "Pmodel30",
                imageUrl: "https://i.ibb.co/Jnyqbnj/gimyk7ewlembuvmrohix.png",
                price: 41.36,
                gender: "men"
            },
            {
                id: 31,
                name: "model31",
                imageUrl: "https://i.ibb.co/YhmG7yL/dcvadu9uxmfnsminamir.png",
                price: 24,
                gender: "men"
            },
            {
                id: 32,
                name: "model32",
                imageUrl: "https://i.ibb.co/dfCj07B/123d9e71-6c1e-4f5b-b9e0-d75235ae738c.png",
                price: 56,
                gender: "men"
            },
            {
                id: 33,
                name: "model33",
                imageUrl: "https://i.ibb.co/b6hjVVJ/05b10425-b994-4e0e-bb7b-1a9e3f270085.png",
                price: 667,
                gender: "men"
            }
        ]
    }
    ,
    // women:{
    //     id: 4,
    //     title: "women",
    //     routeName: "women",
    //      items: []
    // }
};


    
const categoryItems = (Object.keys(SHOP_DATA).map(key => SHOP_DATA[key]["items"])).flat();
const womenItems = categoryItems.filter(item => item["gender"]=="women");
const menItems = categoryItems.filter(item => item["gender"]=="men");
   
SHOP_DATA.women = {
    id: 4,
    title: "women",
    routeName: "women",
    items: womenItems
};

SHOP_DATA.men = {
    id: 5,
    title: "men",
    routeName: "men",
    items: menItems
};


export default SHOP_DATA;